import { useEffect, useRef, useState } from 'react';

export default function CtaSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      ref={sectionRef}
      className="relative py-16 md:py-24"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
        <div
          className={`glass-card rounded-3xl p-10 md:p-14 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-medium text-white mb-5">
            Prête à donner vie à votre projet ?
          </h2>

          <p className="text-white/50 text-base md:text-lg font-light max-w-2xl mx-auto mb-10 leading-relaxed">
            Je vous accompagne pour créer une image digitale claire, élégante et mémorable.
          </p>

          <button
            onClick={() => scrollTo('contact')}
            className="btn-primary px-10 py-4 text-base whitespace-nowrap tracking-wide"
          >
            Discuter de mon projet
          </button>
        </div>
      </div>
    </section>
  );
}
